<template>
  <div class="card">
    <div class="box">
      <div v-if="preview" class="mb-5" style="text-align: center;">
        <h1 class="is-size-5" style="margin: auto;">
          Click a seat to view details
        </h1>
      </div>
      <div v-else class="mb-5" style="text-align: center;">
        <h1 class="is-size-3" style="margin: auto;">Select your seat</h1>
        <h2 class="is-size-6" style="margin: auto;">
          Click a seat to view the details
        </h2>
      </div>
      <div v-if="!areSelectableSeatsAvailable()" class="notification is-danger">
        <p>No seats are available for selection as your company has disallowed selecting paid seats. Seat will be assigned at check in.</p>
      </div>

      <div class="columns is-mobile">
        <!-- <div class="column">
          <FlightDetails :flightDetails="seatmap.flightDetails"></FlightDetails>
          <PassengerDetails v-if="passengers.length > 0" :passengers="passengers"></PassengerDetails>
        </div> -->
        <div class="column">
          <div
            class="seatmap-container has-text-centered pdg"
            style="max-width: 100%"
          >
            <Row
              v-for="(row, rowNumber) in seatmap.seatsGroupedByRow"
              :orientation="tooltipOrientation(rowNumber)"
              @selected="selectSeat"
              :key="rowNumber"
              :seats="row"
              :rowNumber="rowNumber"
              :aisleLeftColumn="aisleLeftColumn"
              :aisleRightColumn="aisleRightColumn"
              :overwingRows="overwingRows"
              :marketingAirline="seatmap.flightDetails.marketingAirline"
            ></Row>
          </div>
        </div>
        <div class="column" style="width: 195px;">
          <FlightDetails :flightDetails="seatmap.flightDetails"></FlightDetails>
          <PassengerDetails
            v-if="passenger && !preview"
            :passengers="passengers"
          ></PassengerDetails>
          <br />
          <div v-if="selectedSeat">
            <h2 class="is-size-4">
              Seat: <b>{{ selectedSeat.id }}</b>
            </h2>

            <ul>
              <!-- <li v-if="selectedSeat.commercialName" class="is-size-7 has-text-weight-bold">
                {{ selectedSeat.commercialName }}
              </li> -->

              <li
                v-for="item in selectedSeat.characteristicsDisplay"
                :key="item"
                class="is-size-7 has-text-grey"
                style=""
              >
                {{ item }}
              </li>
              <li
                v-if="selectedSeat.price"
                class="is-size-7 has-text-grey"
                style=""
              >
                ${{ selectedSeat.price.total }}
              </li>
              <!-- <li v-else class="is-size-7 has-text-grey" style="" >
                No charge
              </li> -->
            </ul>

            <br />
            <b-button
              v-if="!preview"
              class="is-block"
              style="margin: auto;"
              size="is-small"
              @click="confirmSelection()"
              type="is-primary"
              outlined
              expanded
              >Confirm Selection</b-button
            >
          </div>
        </div>
      </div>
      <div v-if="selectedSeat" class="mb-2 is-hidden-desktop">
        <div style="text-align: center;" class="mb-2">
          <h2 class="is-size-4">
            Seat: <b>{{ selectedSeat.id }}</b>
          </h2>
          <p v-if="selectedSeat.price" class="is-size-7 has-text-grey" style="">
            {{ selectedSeat.price.total }}
          </p>

          <p v-else class="is-size-7 has-text-grey" style="">
            No charge
          </p>
        </div>

        <b-button
          v-if="!preview"
          class="is-block"
          style="margin: auto;"
          size="is-small"
          @click="confirmSelection()"
          type="is-primary"
          outlined
          expanded
          >Confirm Selection</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import Row from "./Row";
import FlightDetails from "./FlightDetails";
import PassengerDetails from "./PassengerDetails";
export default {
  components: {
    Row,
    FlightDetails,
    PassengerDetails,
  },
  props: {
    seatmap: Object,
    preview: Boolean,
    passenger: Object,
  },
  data: function() {
    return {
      selectedSeat: null,
      loading: true,
    };
  },
  computed: {
    passengers() {
      return new Array(this.passenger);
    },
    aisleColumns() {
      return this.seatmap.cabin.aisleColumns;

      /* let row = this.seatmap.seatsGroupedByRow[0]

        // console.log(row)

        //let aisleLeftColumn;
        //let aisleRightColumn;
        let aisleColumns = []

        row.forEach((seat) => {
          if (seat.column.code == 'A') {
            if (!this.aisleLeftColumn) {
              aisleColumns[0] = seat.column.name
            } else {
              aisleColumns[1] = seat.column.name
            }
          }
        }) 

        return aisleColumns // needs to be dynamic */
    },
    aisleLeftColumn() {
      if (this.aisleColumns.length == 2) {
        return this.aisleColumns[0];
      }

      return "C"; // needs to be dynamic
    },
    aisleRightColumn() {
      if (this.aisleColumns.length == 2) {
        return this.aisleColumns[1];
      }

      return "D"; // needs to be dynamic
    },
    modifiedSeatmap() {
      return this.seatmap;
    },
    overwingRows() {
      let overwingRows = [];

      // No overwing data, return empty array
      if (!this.seatmap.cabin.overwingSeatRowRange) {
        return overwingRows;
      }

      let rowStart = this.seatmap.cabin.overwingSeatRowRange[0];
      let rowEnd = this.seatmap.cabin.overwingSeatRowRange[1];

      let currentRow = rowStart;

      while (currentRow <= rowEnd) {
        overwingRows.push(currentRow);
        currentRow = currentRow + 1;
      }

      return overwingRows;
    },
    canPurchaseSeat() {
    let tripType = this.$store.getters["travellersAndTrips/getTravellers"].tripType;

    // Allow Paid Seats for Personal Trips
    if (tripType === "personal") {
      return true;
    }

    const selectPaidSeats = this.$store.getters[
      "travellersAndTrips/getCurrentTravellerProfile"
    ].selectPaidSeats;

    return selectPaidSeats === "Allow";
  }
  },
  methods: {

    areSelectableSeatsAvailable() {
    return this.seatmap.seatsGroupedByRow.some(row => 
      row.some(seat => {
        const isPaidSeat = seat.price && seat.price.total > 0;
        return seat.isSelectable && (!isPaidSeat || this.canPurchaseSeat);
      })
    );
  },
    tooltipOrientation(num) {
      var range =
        this.seatmap.cabin.seatRowRange[1] - this.seatmap.cabin.seatRowRange[0];
      if (num < range / 3) {
        return "is-bottom";
      } else {
        return "is-top";
      }
    },
    selectSeat(value) {
      this.selectedSeat = value;
    },
    confirmSelection() {
      this.$emit("selected", this.selectedSeat);
    },
    /*
    async getSeatmap() {
      //this.loading = true

      var raw = {
        departureAirport: "DTW",
        arrivalAirport: "LAX",
        airlineCode: "DL",
        flightNumber: "932",
        departureDate: "2021-04-07",
      };

      this.$app
        .huddleLabsServerCall("amadeus/air/seat-map", raw)
        .then((result) => {
          // console.log(result)
          this.seatmap = result;
          this.loading = false;
        });
      //// console.log(this.seatmap.flightDetails)
    },
    */
  },
  mounted() {
  },
};
</script>

<style scoped>
.seatmap-container {
  display: inline-block;
  overflow-y: scroll;
  overflow-x: scroll;
  max-height: 400px;
  max-width: 100vw;
}

@media screen and (max-width: 1023px) {
}

@media screen and (min-width: 1024px) {
  .pdg {
    padding-right: 60px;
    padding-left: 60px;
    /* background-color: #F5F0E1; */
  }
}
</style>
